var cov_hcwms1f42 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Select/Input.tsx",
      hash = "edebaefc77dffe9f347864a256c24a4eb17d343d",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Select/Input.tsx",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 20
        },
        end: {
          line: 9,
          column: 1
        }
      },
      "1": {
        start: {
          line: 8,
          column: 2
        },
        end: {
          line: 8,
          column: 21
        }
      },
      "2": {
        start: {
          line: 15,
          column: 21
        },
        end: {
          line: 18,
          column: 1
        }
      },
      "3": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 36,
          column: 16
        }
      },
      "4": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 40,
          column: 5
        }
      },
      "5": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 42,
          column: 50
        }
      },
      "6": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 43,
          column: 50
        }
      },
      "7": {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 44,
          column: 48
        }
      },
      "8": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 45,
          column: 50
        }
      },
      "9": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 50
        }
      },
      "10": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 48,
          column: 48
        }
      },
      "11": {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 49,
          column: 72
        }
      },
      "12": {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 50,
          column: 68
        }
      },
      "13": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 53,
          column: 51
        }
      },
      "14": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 56,
          column: 45
        }
      },
      "15": {
        start: {
          line: 60,
          column: 4
        },
        end: {
          line: 63,
          column: 5
        }
      },
      "16": {
        start: {
          line: 61,
          column: 6
        },
        end: {
          line: 61,
          column: 31
        }
      },
      "17": {
        start: {
          line: 62,
          column: 6
        },
        end: {
          line: 62,
          column: 18
        }
      },
      "18": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 67,
          column: 31
        }
      },
      "19": {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 71,
          column: 73
        }
      },
      "20": {
        start: {
          line: 71,
          column: 67
        },
        end: {
          line: 71,
          column: 73
        }
      },
      "21": {
        start: {
          line: 72,
          column: 4
        },
        end: {
          line: 72,
          column: 29
        }
      },
      "22": {
        start: {
          line: 73,
          column: 4
        },
        end: {
          line: 73,
          column: 16
        }
      },
      "23": {
        start: {
          line: 77,
          column: 21
        },
        end: {
          line: 77,
          column: 31
        }
      },
      "24": {
        start: {
          line: 78,
          column: 4
        },
        end: {
          line: 78,
          column: 80
        }
      },
      "25": {
        start: {
          line: 78,
          column: 71
        },
        end: {
          line: 78,
          column: 80
        }
      },
      "26": {
        start: {
          line: 79,
          column: 4
        },
        end: {
          line: 79,
          column: 60
        }
      },
      "27": {
        start: {
          line: 83,
          column: 26
        },
        end: {
          line: 83,
          column: 36
        }
      },
      "28": {
        start: {
          line: 84,
          column: 4
        },
        end: {
          line: 99,
          column: 5
        }
      },
      "29": {
        start: {
          line: 87,
          column: 8
        },
        end: {
          line: 94,
          column: 9
        }
      },
      "30": {
        start: {
          line: 88,
          column: 28
        },
        end: {
          line: 88,
          column: 49
        }
      },
      "31": {
        start: {
          line: 89,
          column: 10
        },
        end: {
          line: 93,
          column: 11
        }
      },
      "32": {
        start: {
          line: 103,
          column: 26
        },
        end: {
          line: 103,
          column: 36
        }
      },
      "33": {
        start: {
          line: 104,
          column: 4
        },
        end: {
          line: 106,
          column: 5
        }
      },
      "34": {
        start: {
          line: 105,
          column: 6
        },
        end: {
          line: 105,
          column: 17
        }
      },
      "35": {
        start: {
          line: 107,
          column: 17
        },
        end: {
          line: 107,
          column: 21
        }
      },
      "36": {
        start: {
          line: 108,
          column: 17
        },
        end: {
          line: 108,
          column: 52
        }
      },
      "37": {
        start: {
          line: 109,
          column: 4
        },
        end: {
          line: 148,
          column: 5
        }
      },
      "38": {
        start: {
          line: 112,
          column: 6
        },
        end: {
          line: 114,
          column: 7
        }
      },
      "39": {
        start: {
          line: 113,
          column: 8
        },
        end: {
          line: 113,
          column: 110
        }
      },
      "40": {
        start: {
          line: 115,
          column: 6
        },
        end: {
          line: 131,
          column: 7
        }
      },
      "41": {
        start: {
          line: 116,
          column: 8
        },
        end: {
          line: 116,
          column: 52
        }
      },
      "42": {
        start: {
          line: 118,
          column: 13
        },
        end: {
          line: 131,
          column: 7
        }
      },
      "43": {
        start: {
          line: 119,
          column: 57
        },
        end: {
          line: 119,
          column: 72
        }
      },
      "44": {
        start: {
          line: 120,
          column: 22
        },
        end: {
          line: 120,
          column: 77
        }
      },
      "45": {
        start: {
          line: 121,
          column: 20
        },
        end: {
          line: 121,
          column: 75
        }
      },
      "46": {
        start: {
          line: 122,
          column: 8
        },
        end: {
          line: 128,
          column: 9
        }
      },
      "47": {
        start: {
          line: 123,
          column: 10
        },
        end: {
          line: 124,
          column: 104
        }
      },
      "48": {
        start: {
          line: 125,
          column: 10
        },
        end: {
          line: 125,
          column: 31
        }
      },
      "49": {
        start: {
          line: 127,
          column: 10
        },
        end: {
          line: 127,
          column: 24
        }
      },
      "50": {
        start: {
          line: 130,
          column: 8
        },
        end: {
          line: 130,
          column: 22
        }
      },
      "51": {
        start: {
          line: 133,
          column: 6
        },
        end: {
          line: 134,
          column: 7
        }
      },
      "52": {
        start: {
          line: 134,
          column: 7
        },
        end: {
          line: 134,
          column: 62
        }
      },
      "53": {
        start: {
          line: 136,
          column: 6
        },
        end: {
          line: 145,
          column: 7
        }
      },
      "54": {
        start: {
          line: 137,
          column: 26
        },
        end: {
          line: 137,
          column: 47
        }
      },
      "55": {
        start: {
          line: 138,
          column: 22
        },
        end: {
          line: 138,
          column: 46
        }
      },
      "56": {
        start: {
          line: 139,
          column: 23
        },
        end: {
          line: 139,
          column: 43
        }
      },
      "57": {
        start: {
          line: 140,
          column: 8
        },
        end: {
          line: 142,
          column: 9
        }
      },
      "58": {
        start: {
          line: 141,
          column: 11
        },
        end: {
          line: 141,
          column: 50
        }
      },
      "59": {
        start: {
          line: 143,
          column: 8
        },
        end: {
          line: 143,
          column: 41
        }
      },
      "60": {
        start: {
          line: 144,
          column: 8
        },
        end: {
          line: 144,
          column: 28
        }
      },
      "61": {
        start: {
          line: 147,
          column: 6
        },
        end: {
          line: 147,
          column: 28
        }
      },
      "62": {
        start: {
          line: 150,
          column: 4
        },
        end: {
          line: 150,
          column: 17
        }
      },
      "63": {
        start: {
          line: 154,
          column: 4
        },
        end: {
          line: 154,
          column: 57
        }
      },
      "64": {
        start: {
          line: 154,
          column: 26
        },
        end: {
          line: 154,
          column: 57
        }
      },
      "65": {
        start: {
          line: 155,
          column: 4
        },
        end: {
          line: 155,
          column: 52
        }
      },
      "66": {
        start: {
          line: 155,
          column: 24
        },
        end: {
          line: 155,
          column: 52
        }
      },
      "67": {
        start: {
          line: 159,
          column: 4
        },
        end: {
          line: 164,
          column: 5
        }
      },
      "68": {
        start: {
          line: 160,
          column: 6
        },
        end: {
          line: 162,
          column: 8
        }
      },
      "69": {
        start: {
          line: 163,
          column: 6
        },
        end: {
          line: 163,
          column: 12
        }
      },
      "70": {
        start: {
          line: 165,
          column: 4
        },
        end: {
          line: 170,
          column: 5
        }
      },
      "71": {
        start: {
          line: 169,
          column: 12
        },
        end: {
          line: 169,
          column: 24
        }
      },
      "72": {
        start: {
          line: 174,
          column: 30
        },
        end: {
          line: 174,
          column: 40
        }
      },
      "73": {
        start: {
          line: 175,
          column: 19
        },
        end: {
          line: 175,
          column: 73
        }
      },
      "74": {
        start: {
          line: 176,
          column: 4
        },
        end: {
          line: 178,
          column: 6
        }
      },
      "75": {
        start: {
          line: 177,
          column: 6
        },
        end: {
          line: 177,
          column: 30
        }
      },
      "76": {
        start: {
          line: 182,
          column: 4
        },
        end: {
          line: 182,
          column: 25
        }
      },
      "77": {
        start: {
          line: 186,
          column: 25
        },
        end: {
          line: 186,
          column: 35
        }
      },
      "78": {
        start: {
          line: 187,
          column: 19
        },
        end: {
          line: 187,
          column: 38
        }
      },
      "79": {
        start: {
          line: 188,
          column: 4
        },
        end: {
          line: 190,
          column: 5
        }
      },
      "80": {
        start: {
          line: 189,
          column: 6
        },
        end: {
          line: 189,
          column: 12
        }
      },
      "81": {
        start: {
          line: 191,
          column: 17
        },
        end: {
          line: 191,
          column: 74
        }
      },
      "82": {
        start: {
          line: 192,
          column: 4
        },
        end: {
          line: 192,
          column: 56
        }
      },
      "83": {
        start: {
          line: 193,
          column: 14
        },
        end: {
          line: 193,
          column: 42
        }
      },
      "84": {
        start: {
          line: 194,
          column: 4
        },
        end: {
          line: 194,
          column: 29
        }
      },
      "85": {
        start: {
          line: 194,
          column: 18
        },
        end: {
          line: 194,
          column: 29
        }
      },
      "86": {
        start: {
          line: 198,
          column: 26
        },
        end: {
          line: 198,
          column: 36
        }
      },
      "87": {
        start: {
          line: 199,
          column: 17
        },
        end: {
          line: 199,
          column: 98
        }
      },
      "88": {
        start: {
          line: 200,
          column: 4
        },
        end: {
          line: 200,
          column: 26
        }
      },
      "89": {
        start: {
          line: 201,
          column: 4
        },
        end: {
          line: 201,
          column: 28
        }
      },
      "90": {
        start: {
          line: 201,
          column: 22
        },
        end: {
          line: 201,
          column: 28
        }
      },
      "91": {
        start: {
          line: 202,
          column: 4
        },
        end: {
          line: 202,
          column: 32
        }
      },
      "92": {
        start: {
          line: 206,
          column: 4
        },
        end: {
          line: 206,
          column: 27
        }
      },
      "93": {
        start: {
          line: 210,
          column: 4
        },
        end: {
          line: 210,
          column: 28
        }
      },
      "94": {
        start: {
          line: 211,
          column: 4
        },
        end: {
          line: 211,
          column: 23
        }
      },
      "95": {
        start: {
          line: 215,
          column: 38
        },
        end: {
          line: 215,
          column: 48
        }
      },
      "96": {
        start: {
          line: 216,
          column: 18
        },
        end: {
          line: 216,
          column: 83
        }
      },
      "97": {
        start: {
          line: 217,
          column: 18
        },
        end: {
          line: 228,
          column: 5
        }
      },
      "98": {
        start: {
          line: 229,
          column: 4
        },
        end: {
          line: 242,
          column: 5
        }
      },
      "99": {
        start: {
          line: 230,
          column: 6
        },
        end: {
          line: 235,
          column: 7
        }
      },
      "100": {
        start: {
          line: 231,
          column: 8
        },
        end: {
          line: 234,
          column: 10
        }
      },
      "101": {
        start: {
          line: 236,
          column: 6
        },
        end: {
          line: 241,
          column: 8
        }
      },
      "102": {
        start: {
          line: 244,
          column: 4
        },
        end: {
          line: 244,
          column: 101
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 7,
            column: 20
          },
          end: {
            line: 7,
            column: 21
          }
        },
        loc: {
          start: {
            line: 7,
            column: 45
          },
          end: {
            line: 9,
            column: 1
          }
        },
        line: 7
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 35,
            column: 2
          },
          end: {
            line: 35,
            column: 3
          }
        },
        loc: {
          start: {
            line: 35,
            column: 33
          },
          end: {
            line: 57,
            column: 3
          }
        },
        line: 35
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 59,
            column: 2
          },
          end: {
            line: 59,
            column: 3
          }
        },
        loc: {
          start: {
            line: 59,
            column: 22
          },
          end: {
            line: 64,
            column: 3
          }
        },
        line: 59
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 66,
            column: 2
          },
          end: {
            line: 66,
            column: 3
          }
        },
        loc: {
          start: {
            line: 66,
            column: 26
          },
          end: {
            line: 68,
            column: 3
          }
        },
        line: 66
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 70,
            column: 2
          },
          end: {
            line: 70,
            column: 3
          }
        },
        loc: {
          start: {
            line: 70,
            column: 44
          },
          end: {
            line: 74,
            column: 3
          }
        },
        line: 70
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 76,
            column: 2
          },
          end: {
            line: 76,
            column: 3
          }
        },
        loc: {
          start: {
            line: 76,
            column: 34
          },
          end: {
            line: 80,
            column: 3
          }
        },
        line: 76
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 82,
            column: 2
          },
          end: {
            line: 82,
            column: 3
          }
        },
        loc: {
          start: {
            line: 82,
            column: 39
          },
          end: {
            line: 100,
            column: 3
          }
        },
        line: 82
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 86,
            column: 6
          },
          end: {
            line: 86,
            column: 7
          }
        },
        loc: {
          start: {
            line: 86,
            column: 24
          },
          end: {
            line: 95,
            column: 7
          }
        },
        line: 86
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 102,
            column: 2
          },
          end: {
            line: 102,
            column: 3
          }
        },
        loc: {
          start: {
            line: 102,
            column: 36
          },
          end: {
            line: 151,
            column: 3
          }
        },
        line: 102
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 153,
            column: 2
          },
          end: {
            line: 153,
            column: 3
          }
        },
        loc: {
          start: {
            line: 153,
            column: 10
          },
          end: {
            line: 156,
            column: 3
          }
        },
        line: 153
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 158,
            column: 2
          },
          end: {
            line: 158,
            column: 3
          }
        },
        loc: {
          start: {
            line: 158,
            column: 27
          },
          end: {
            line: 171,
            column: 3
          }
        },
        line: 158
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 169,
            column: 6
          },
          end: {
            line: 169,
            column: 7
          }
        },
        loc: {
          start: {
            line: 169,
            column: 12
          },
          end: {
            line: 169,
            column: 24
          }
        },
        line: 169
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 173,
            column: 2
          },
          end: {
            line: 173,
            column: 3
          }
        },
        loc: {
          start: {
            line: 173,
            column: 10
          },
          end: {
            line: 179,
            column: 3
          }
        },
        line: 173
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 176,
            column: 26
          },
          end: {
            line: 176,
            column: 27
          }
        },
        loc: {
          start: {
            line: 176,
            column: 32
          },
          end: {
            line: 178,
            column: 5
          }
        },
        line: 176
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 181,
            column: 2
          },
          end: {
            line: 181,
            column: 3
          }
        },
        loc: {
          start: {
            line: 181,
            column: 35
          },
          end: {
            line: 183,
            column: 3
          }
        },
        line: 181
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 185,
            column: 2
          },
          end: {
            line: 185,
            column: 3
          }
        },
        loc: {
          start: {
            line: 185,
            column: 22
          },
          end: {
            line: 195,
            column: 3
          }
        },
        line: 185
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 197,
            column: 2
          },
          end: {
            line: 197,
            column: 3
          }
        },
        loc: {
          start: {
            line: 197,
            column: 34
          },
          end: {
            line: 203,
            column: 3
          }
        },
        line: 197
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 205,
            column: 2
          },
          end: {
            line: 205,
            column: 3
          }
        },
        loc: {
          start: {
            line: 205,
            column: 27
          },
          end: {
            line: 207,
            column: 3
          }
        },
        line: 205
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 209,
            column: 2
          },
          end: {
            line: 209,
            column: 3
          }
        },
        loc: {
          start: {
            line: 209,
            column: 31
          },
          end: {
            line: 212,
            column: 3
          }
        },
        line: 209
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 214,
            column: 2
          },
          end: {
            line: 214,
            column: 3
          }
        },
        loc: {
          start: {
            line: 214,
            column: 11
          },
          end: {
            line: 245,
            column: 3
          }
        },
        line: 214
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 60,
            column: 4
          },
          end: {
            line: 63,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 60,
            column: 4
          },
          end: {
            line: 63,
            column: 5
          }
        }, {
          start: {
            line: 60,
            column: 4
          },
          end: {
            line: 63,
            column: 5
          }
        }],
        line: 60
      },
      "1": {
        loc: {
          start: {
            line: 71,
            column: 4
          },
          end: {
            line: 71,
            column: 73
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 71,
            column: 4
          },
          end: {
            line: 71,
            column: 73
          }
        }, {
          start: {
            line: 71,
            column: 4
          },
          end: {
            line: 71,
            column: 73
          }
        }],
        line: 71
      },
      "2": {
        loc: {
          start: {
            line: 71,
            column: 8
          },
          end: {
            line: 71,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 71,
            column: 8
          },
          end: {
            line: 71,
            column: 44
          }
        }, {
          start: {
            line: 71,
            column: 48
          },
          end: {
            line: 71,
            column: 65
          }
        }],
        line: 71
      },
      "3": {
        loc: {
          start: {
            line: 78,
            column: 4
          },
          end: {
            line: 78,
            column: 80
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 78,
            column: 4
          },
          end: {
            line: 78,
            column: 80
          }
        }, {
          start: {
            line: 78,
            column: 4
          },
          end: {
            line: 78,
            column: 80
          }
        }],
        line: 78
      },
      "4": {
        loc: {
          start: {
            line: 78,
            column: 8
          },
          end: {
            line: 78,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 78,
            column: 8
          },
          end: {
            line: 78,
            column: 13
          }
        }, {
          start: {
            line: 78,
            column: 17
          },
          end: {
            line: 78,
            column: 44
          }
        }, {
          start: {
            line: 78,
            column: 48
          },
          end: {
            line: 78,
            column: 69
          }
        }],
        line: 78
      },
      "5": {
        loc: {
          start: {
            line: 79,
            column: 11
          },
          end: {
            line: 79,
            column: 60
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 79,
            column: 18
          },
          end: {
            line: 79,
            column: 29
          }
        }, {
          start: {
            line: 79,
            column: 32
          },
          end: {
            line: 79,
            column: 60
          }
        }],
        line: 79
      },
      "6": {
        loc: {
          start: {
            line: 87,
            column: 8
          },
          end: {
            line: 94,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 87,
            column: 8
          },
          end: {
            line: 94,
            column: 9
          }
        }, {
          start: {
            line: 87,
            column: 8
          },
          end: {
            line: 94,
            column: 9
          }
        }],
        line: 87
      },
      "7": {
        loc: {
          start: {
            line: 104,
            column: 4
          },
          end: {
            line: 106,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 104,
            column: 4
          },
          end: {
            line: 106,
            column: 5
          }
        }, {
          start: {
            line: 104,
            column: 4
          },
          end: {
            line: 106,
            column: 5
          }
        }],
        line: 104
      },
      "8": {
        loc: {
          start: {
            line: 104,
            column: 8
          },
          end: {
            line: 104,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 104,
            column: 8
          },
          end: {
            line: 104,
            column: 18
          }
        }, {
          start: {
            line: 104,
            column: 22
          },
          end: {
            line: 104,
            column: 38
          }
        }],
        line: 104
      },
      "9": {
        loc: {
          start: {
            line: 109,
            column: 4
          },
          end: {
            line: 148,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 109,
            column: 4
          },
          end: {
            line: 148,
            column: 5
          }
        }, {
          start: {
            line: 109,
            column: 4
          },
          end: {
            line: 148,
            column: 5
          }
        }],
        line: 109
      },
      "10": {
        loc: {
          start: {
            line: 112,
            column: 6
          },
          end: {
            line: 114,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 112,
            column: 6
          },
          end: {
            line: 114,
            column: 7
          }
        }, {
          start: {
            line: 112,
            column: 6
          },
          end: {
            line: 114,
            column: 7
          }
        }],
        line: 112
      },
      "11": {
        loc: {
          start: {
            line: 113,
            column: 66
          },
          end: {
            line: 113,
            column: 97
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 113,
            column: 92
          },
          end: {
            line: 113,
            column: 93
          }
        }, {
          start: {
            line: 113,
            column: 96
          },
          end: {
            line: 113,
            column: 97
          }
        }],
        line: 113
      },
      "12": {
        loc: {
          start: {
            line: 115,
            column: 6
          },
          end: {
            line: 131,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 115,
            column: 6
          },
          end: {
            line: 131,
            column: 7
          }
        }, {
          start: {
            line: 115,
            column: 6
          },
          end: {
            line: 131,
            column: 7
          }
        }],
        line: 115
      },
      "13": {
        loc: {
          start: {
            line: 118,
            column: 13
          },
          end: {
            line: 131,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 118,
            column: 13
          },
          end: {
            line: 131,
            column: 7
          }
        }, {
          start: {
            line: 118,
            column: 13
          },
          end: {
            line: 131,
            column: 7
          }
        }],
        line: 118
      },
      "14": {
        loc: {
          start: {
            line: 118,
            column: 17
          },
          end: {
            line: 118,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 118,
            column: 17
          },
          end: {
            line: 118,
            column: 32
          }
        }, {
          start: {
            line: 118,
            column: 36
          },
          end: {
            line: 118,
            column: 72
          }
        }],
        line: 118
      },
      "15": {
        loc: {
          start: {
            line: 120,
            column: 22
          },
          end: {
            line: 120,
            column: 77
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 120,
            column: 51
          },
          end: {
            line: 120,
            column: 63
          }
        }, {
          start: {
            line: 120,
            column: 66
          },
          end: {
            line: 120,
            column: 77
          }
        }],
        line: 120
      },
      "16": {
        loc: {
          start: {
            line: 121,
            column: 20
          },
          end: {
            line: 121,
            column: 75
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 121,
            column: 49
          },
          end: {
            line: 121,
            column: 61
          }
        }, {
          start: {
            line: 121,
            column: 64
          },
          end: {
            line: 121,
            column: 75
          }
        }],
        line: 121
      },
      "17": {
        loc: {
          start: {
            line: 122,
            column: 8
          },
          end: {
            line: 128,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 122,
            column: 8
          },
          end: {
            line: 128,
            column: 9
          }
        }, {
          start: {
            line: 122,
            column: 8
          },
          end: {
            line: 128,
            column: 9
          }
        }],
        line: 122
      },
      "18": {
        loc: {
          start: {
            line: 136,
            column: 6
          },
          end: {
            line: 145,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 136,
            column: 6
          },
          end: {
            line: 145,
            column: 7
          }
        }, {
          start: {
            line: 136,
            column: 6
          },
          end: {
            line: 145,
            column: 7
          }
        }],
        line: 136
      },
      "19": {
        loc: {
          start: {
            line: 140,
            column: 8
          },
          end: {
            line: 142,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 140,
            column: 8
          },
          end: {
            line: 142,
            column: 9
          }
        }, {
          start: {
            line: 140,
            column: 8
          },
          end: {
            line: 142,
            column: 9
          }
        }],
        line: 140
      },
      "20": {
        loc: {
          start: {
            line: 154,
            column: 4
          },
          end: {
            line: 154,
            column: 57
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 154,
            column: 4
          },
          end: {
            line: 154,
            column: 57
          }
        }, {
          start: {
            line: 154,
            column: 4
          },
          end: {
            line: 154,
            column: 57
          }
        }],
        line: 154
      },
      "21": {
        loc: {
          start: {
            line: 155,
            column: 4
          },
          end: {
            line: 155,
            column: 52
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 155,
            column: 4
          },
          end: {
            line: 155,
            column: 52
          }
        }, {
          start: {
            line: 155,
            column: 4
          },
          end: {
            line: 155,
            column: 52
          }
        }],
        line: 155
      },
      "22": {
        loc: {
          start: {
            line: 158,
            column: 13
          },
          end: {
            line: 158,
            column: 25
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 158,
            column: 20
          },
          end: {
            line: 158,
            column: 25
          }
        }],
        line: 158
      },
      "23": {
        loc: {
          start: {
            line: 159,
            column: 4
          },
          end: {
            line: 164,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 159,
            column: 4
          },
          end: {
            line: 164,
            column: 5
          }
        }, {
          start: {
            line: 159,
            column: 4
          },
          end: {
            line: 164,
            column: 5
          }
        }],
        line: 159
      },
      "24": {
        loc: {
          start: {
            line: 175,
            column: 19
          },
          end: {
            line: 175,
            column: 73
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 175,
            column: 35
          },
          end: {
            line: 175,
            column: 54
          }
        }, {
          start: {
            line: 175,
            column: 57
          },
          end: {
            line: 175,
            column: 73
          }
        }],
        line: 175
      },
      "25": {
        loc: {
          start: {
            line: 188,
            column: 4
          },
          end: {
            line: 190,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 188,
            column: 4
          },
          end: {
            line: 190,
            column: 5
          }
        }, {
          start: {
            line: 188,
            column: 4
          },
          end: {
            line: 190,
            column: 5
          }
        }],
        line: 188
      },
      "26": {
        loc: {
          start: {
            line: 194,
            column: 4
          },
          end: {
            line: 194,
            column: 29
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 194,
            column: 4
          },
          end: {
            line: 194,
            column: 29
          }
        }, {
          start: {
            line: 194,
            column: 4
          },
          end: {
            line: 194,
            column: 29
          }
        }],
        line: 194
      },
      "27": {
        loc: {
          start: {
            line: 201,
            column: 4
          },
          end: {
            line: 201,
            column: 28
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 201,
            column: 4
          },
          end: {
            line: 201,
            column: 28
          }
        }, {
          start: {
            line: 201,
            column: 4
          },
          end: {
            line: 201,
            column: 28
          }
        }],
        line: 201
      },
      "28": {
        loc: {
          start: {
            line: 216,
            column: 18
          },
          end: {
            line: 216,
            column: 83
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 216,
            column: 45
          },
          end: {
            line: 216,
            column: 76
          }
        }, {
          start: {
            line: 216,
            column: 79
          },
          end: {
            line: 216,
            column: 83
          }
        }],
        line: 216
      },
      "29": {
        loc: {
          start: {
            line: 218,
            column: 38
          },
          end: {
            line: 218,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 218,
            column: 38
          },
          end: {
            line: 218,
            column: 44
          }
        }, {
          start: {
            line: 218,
            column: 48
          },
          end: {
            line: 218,
            column: 58
          }
        }],
        line: 218
      },
      "30": {
        loc: {
          start: {
            line: 218,
            column: 60
          },
          end: {
            line: 218,
            column: 79
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 218,
            column: 60
          },
          end: {
            line: 218,
            column: 69
          }
        }, {
          start: {
            line: 218,
            column: 73
          },
          end: {
            line: 218,
            column: 79
          }
        }],
        line: 218
      },
      "31": {
        loc: {
          start: {
            line: 222,
            column: 23
          },
          end: {
            line: 222,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 222,
            column: 23
          },
          end: {
            line: 222,
            column: 28
          }
        }, {
          start: {
            line: 222,
            column: 32
          },
          end: {
            line: 222,
            column: 51
          }
        }],
        line: 222
      },
      "32": {
        loc: {
          start: {
            line: 225,
            column: 13
          },
          end: {
            line: 225,
            column: 58
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 225,
            column: 41
          },
          end: {
            line: 225,
            column: 46
          }
        }, {
          start: {
            line: 225,
            column: 49
          },
          end: {
            line: 225,
            column: 58
          }
        }],
        line: 225
      },
      "33": {
        loc: {
          start: {
            line: 225,
            column: 13
          },
          end: {
            line: 225,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 225,
            column: 13
          },
          end: {
            line: 225,
            column: 19
          }
        }, {
          start: {
            line: 225,
            column: 23
          },
          end: {
            line: 225,
            column: 38
          }
        }],
        line: 225
      },
      "34": {
        loc: {
          start: {
            line: 229,
            column: 4
          },
          end: {
            line: 242,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 229,
            column: 4
          },
          end: {
            line: 242,
            column: 5
          }
        }, {
          start: {
            line: 229,
            column: 4
          },
          end: {
            line: 242,
            column: 5
          }
        }],
        line: 229
      },
      "35": {
        loc: {
          start: {
            line: 230,
            column: 6
          },
          end: {
            line: 235,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 230,
            column: 6
          },
          end: {
            line: 235,
            column: 7
          }
        }, {
          start: {
            line: 230,
            column: 6
          },
          end: {
            line: 235,
            column: 7
          }
        }],
        line: 230
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Select/Input.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Component, isValidElement, cloneElement } from 'react';
import { selectClass } from './styles';
import { focusElement, getCursorOffset, preventPasteFile } from '../utils/dom/element';
import { isString } from '../utils/is';
cov_hcwms1f42.s[0]++;

var handleFocus = function handleFocus(e) {
  cov_hcwms1f42.f[0]++;
  cov_hcwms1f42.s[1]++;
  e.stopPropagation();
};

var DefaultValue = (cov_hcwms1f42.s[2]++, {
  text: '',
  updatAble: false
});

var FilterInput =
/*#__PURE__*/
function (_Component) {
  _inherits(FilterInput, _Component);

  var _super = _createSuper2(FilterInput);

  function FilterInput(props) {
    var _this;

    _classCallCheck(this, FilterInput);

    cov_hcwms1f42.f[1]++;
    cov_hcwms1f42.s[3]++;
    _this = _super.call(this, props);
    _this.lastCursorOffset = void 0;
    _this.composition = void 0;
    _this.editElement = void 0;
    _this.lastSelect = void 0;
    _this.lastMaxValue = void 0;
    _this.blurTimer = void 0;
    cov_hcwms1f42.s[4]++;
    _this.state = {
      editable: false
    };
    cov_hcwms1f42.s[5]++;
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_this));
    cov_hcwms1f42.s[6]++;
    _this.handleInput = _this.handleInput.bind(_assertThisInitialized(_this));
    cov_hcwms1f42.s[7]++;
    _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_this));
    cov_hcwms1f42.s[8]++;
    _this.geHandleMax = _this.geHandleMax.bind(_assertThisInitialized(_this));
    cov_hcwms1f42.s[9]++;
    _this.handlePaste = _this.handlePaste.bind(_assertThisInitialized(_this));
    cov_hcwms1f42.s[10]++;
    _this.focusInput = _this.focusInput.bind(_assertThisInitialized(_this));
    cov_hcwms1f42.s[11]++;
    _this.handleCompositionStart = _this.handleCompositionStart.bind(_assertThisInitialized(_this));
    cov_hcwms1f42.s[12]++;
    _this.handleCompositionEnd = _this.handleCompositionEnd.bind(_assertThisInitialized(_this)); // for mutiple select

    cov_hcwms1f42.s[13]++;

    _this.props.setInputReset(_this.reset.bind(_assertThisInitialized(_this))); // set focus func to Select


    cov_hcwms1f42.s[14]++;
    props.bindFocusInputFunc(_this.focusInput);
    return _this;
  }

  _createClass(FilterInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_hcwms1f42.f[2]++;
      cov_hcwms1f42.s[15]++;

      if (this.props.focus) {
        cov_hcwms1f42.b[0][0]++;
        cov_hcwms1f42.s[16]++;
        this.props.onInputFocus();
        cov_hcwms1f42.s[17]++;
        this.focus();
      } else {
        cov_hcwms1f42.b[0][1]++;
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      cov_hcwms1f42.f[3]++;
      cov_hcwms1f42.s[18]++;
      return this.props.updatAble;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      cov_hcwms1f42.f[4]++;
      cov_hcwms1f42.s[19]++;

      if ((cov_hcwms1f42.b[2][0]++, this.props.focus === prevProps.focus) || (cov_hcwms1f42.b[2][1]++, !this.props.focus)) {
        cov_hcwms1f42.b[1][0]++;
        cov_hcwms1f42.s[20]++;
        return;
      } else {
        cov_hcwms1f42.b[1][1]++;
      }

      cov_hcwms1f42.s[21]++;
      this.props.onInputFocus();
      cov_hcwms1f42.s[22]++;
      this.focus();
    }
  }, {
    key: "getProcessedValue",
    value: function getProcessedValue(text) {
      cov_hcwms1f42.f[5]++;

      var _ref = (cov_hcwms1f42.s[23]++, this.props),
          trim = _ref.trim;

      cov_hcwms1f42.s[24]++;

      if ((cov_hcwms1f42.b[4][0]++, !trim) && (cov_hcwms1f42.b[4][1]++, this.lastCursorOffset === 0) && (cov_hcwms1f42.b[4][2]++, /^\u00A0$/.test(text))) {
        cov_hcwms1f42.b[3][0]++;
        cov_hcwms1f42.s[25]++;
        return '';
      } else {
        cov_hcwms1f42.b[3][1]++;
      }

      cov_hcwms1f42.s[26]++;
      return trim ? (cov_hcwms1f42.b[5][0]++, text.trim()) : (cov_hcwms1f42.b[5][1]++, text.replace(/\u00A0/g, ' '));
    }
  }, {
    key: "handlePaste",
    value: function handlePaste(e) {
      var _this2 = this;

      cov_hcwms1f42.f[6]++;

      var _ref2 = (cov_hcwms1f42.s[27]++, this.props),
          convertBr = _ref2.convertBr;

      cov_hcwms1f42.s[28]++;
      preventPasteFile(e, function (text) {
        cov_hcwms1f42.f[7]++;
        cov_hcwms1f42.s[29]++;

        if (window.getSelection) {
          cov_hcwms1f42.b[6][0]++;
          var selection = (cov_hcwms1f42.s[30]++, window.getSelection());
          cov_hcwms1f42.s[31]++;
          _this2.lastSelect = {
            anchorOffset: selection.anchorOffset,
            focusOffset: selection.focusOffset,
            text: text
          };
        } else {
          cov_hcwms1f42.b[6][1]++;
        }
      }, {
        convertBr: convertBr
      });
    }
  }, {
    key: "geHandleMax",
    value: function geHandleMax(e) {
      cov_hcwms1f42.f[8]++;

      var _ref3 = (cov_hcwms1f42.s[32]++, this.props),
          maxLength = _ref3.maxLength;

      cov_hcwms1f42.s[33]++;

      if ((cov_hcwms1f42.b[8][0]++, !maxLength) || (cov_hcwms1f42.b[8][1]++, this.composition)) {
        cov_hcwms1f42.b[7][0]++;
        cov_hcwms1f42.s[34]++;
        return true;
      } else {
        cov_hcwms1f42.b[7][1]++;
      }

      var change = (cov_hcwms1f42.s[35]++, true);
      var text = (cov_hcwms1f42.s[36]++, e.target.innerText);
      cov_hcwms1f42.s[37]++;

      if (text.length >= maxLength) {
        cov_hcwms1f42.b[9][0]++;
        var lastPos; // 输入的位置 需要考虑选中文本的情况

        cov_hcwms1f42.s[38]++;

        if (window.getSelection) {
          cov_hcwms1f42.b[10][0]++;
          cov_hcwms1f42.s[39]++;
          lastPos = Math.min(window.getSelection().anchorOffset - (text.length > maxLength ? (cov_hcwms1f42.b[11][0]++, 1) : (cov_hcwms1f42.b[11][1]++, 0)), maxLength);
        } else {
          cov_hcwms1f42.b[10][1]++;
        }

        cov_hcwms1f42.s[40]++;

        if (!this.lastMaxValue) {
          cov_hcwms1f42.b[12][0]++;
          cov_hcwms1f42.s[41]++;
          this.lastMaxValue = text.slice(0, maxLength); // 粘贴文本的情况
        } else {
          cov_hcwms1f42.b[12][1]++;
          cov_hcwms1f42.s[42]++;

          if ((cov_hcwms1f42.b[14][0]++, this.lastSelect) && (cov_hcwms1f42.b[14][1]++, typeof this.lastSelect !== 'boolean')) {
            cov_hcwms1f42.b[13][0]++;

            var _ref4 = (cov_hcwms1f42.s[43]++, this.lastSelect),
                _anchorOffset = _ref4.anchorOffset,
                _focusOffset = _ref4.focusOffset,
                str = _ref4.text;

            var start = (cov_hcwms1f42.s[44]++, _anchorOffset < _focusOffset ? (cov_hcwms1f42.b[15][0]++, _anchorOffset) : (cov_hcwms1f42.b[15][1]++, _focusOffset));
            var end = (cov_hcwms1f42.s[45]++, _anchorOffset > _focusOffset ? (cov_hcwms1f42.b[16][0]++, _anchorOffset) : (cov_hcwms1f42.b[16][1]++, _focusOffset));
            cov_hcwms1f42.s[46]++;

            if (end - start > 0) {
              cov_hcwms1f42.b[17][0]++;
              cov_hcwms1f42.s[47]++;
              this.lastMaxValue = this.lastMaxValue.slice(0, start) + str.slice(0, end - start) + this.lastMaxValue.slice(end);
              cov_hcwms1f42.s[48]++;
              lastPos = _focusOffset;
            } else {
              cov_hcwms1f42.b[17][1]++;
              cov_hcwms1f42.s[49]++;
              change = false;
            }
          } else {
            cov_hcwms1f42.b[13][1]++;
            cov_hcwms1f42.s[50]++;
            change = false;
          }
        } // clear select info


        cov_hcwms1f42.s[51]++;
        this.lastSelect = false;
        cov_hcwms1f42.s[52]++;
        e.target.innerText = this.lastMaxValue; // 修改e.target.innerText后光标会变到最前面，这儿改变光标位置到上次光标的位置

        cov_hcwms1f42.s[53]++;

        if (lastPos) {
          cov_hcwms1f42.b[18][0]++;
          var selection = (cov_hcwms1f42.s[54]++, window.getSelection());
          var range = (cov_hcwms1f42.s[55]++, selection.getRangeAt(0));
          var textNode = (cov_hcwms1f42.s[56]++, range.startContainer);
          cov_hcwms1f42.s[57]++;

          if (textNode.nodeName !== '#text') {
            cov_hcwms1f42.b[19][0]++;
            ;
            cov_hcwms1f42.s[58]++;
            var _ref5 = textNode.childNodes;

            var _ref6 = _slicedToArray(_ref5, 1);

            textNode = _ref6[0];
          } else {
            cov_hcwms1f42.b[19][1]++;
          }

          cov_hcwms1f42.s[59]++;
          range.setStart(textNode, lastPos);
          cov_hcwms1f42.s[60]++;
          range.collapse(true);
        } else {
          cov_hcwms1f42.b[18][1]++;
        }
      } else {
        cov_hcwms1f42.b[9][1]++;
        cov_hcwms1f42.s[61]++;
        this.lastMaxValue = '';
      } // eslint-disable-next-line consistent-return


      cov_hcwms1f42.s[62]++;
      return change;
    }
  }, {
    key: "reset",
    value: function reset() {
      cov_hcwms1f42.f[9]++;
      cov_hcwms1f42.s[63]++;

      if (this.editElement) {
        cov_hcwms1f42.b[20][0]++;
        cov_hcwms1f42.s[64]++;
        this.editElement.innerText = '';
      } else {
        cov_hcwms1f42.b[20][1]++;
      }

      cov_hcwms1f42.s[65]++;

      if (this.blurTimer) {
        cov_hcwms1f42.b[21][0]++;
        cov_hcwms1f42.s[66]++;
        clearTimeout(this.blurTimer);
      } else {
        cov_hcwms1f42.b[21][1]++;
      }
    }
  }, {
    key: "focusInput",
    value: function focusInput() {
      var _this3 = this;

      var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_hcwms1f42.b[22][0]++, false);
      cov_hcwms1f42.f[10]++;
      cov_hcwms1f42.s[67]++;

      if (!flag) {
        cov_hcwms1f42.b[23][0]++;
        cov_hcwms1f42.s[68]++;
        this.setState({
          editable: false
        });
        cov_hcwms1f42.s[69]++;
        return;
      } else {
        cov_hcwms1f42.b[23][1]++;
      }

      cov_hcwms1f42.s[70]++;
      this.setState({
        editable: true
      }, function () {
        cov_hcwms1f42.f[11]++;
        cov_hcwms1f42.s[71]++;
        return _this3.focus();
      });
    }
  }, {
    key: "focus",
    value: function focus() {
      var _this4 = this;

      cov_hcwms1f42.f[12]++;

      var _ref7 = (cov_hcwms1f42.s[72]++, this.props),
          focusSelected = _ref7.focusSelected;

      var action = (cov_hcwms1f42.s[73]++, focusSelected ? (cov_hcwms1f42.b[24][0]++, focusElement.select) : (cov_hcwms1f42.b[24][1]++, focusElement.end));
      cov_hcwms1f42.s[74]++;
      requestAnimationFrame(function () {
        cov_hcwms1f42.f[13]++;
        cov_hcwms1f42.s[75]++;
        action(_this4.editElement);
      });
    }
  }, {
    key: "bindElement",
    value: function bindElement(el) {
      cov_hcwms1f42.f[14]++;
      cov_hcwms1f42.s[76]++;
      this.editElement = el;
    }
  }, {
    key: "handleInput",
    value: function handleInput(e) {
      cov_hcwms1f42.f[15]++;

      var _ref8 = (cov_hcwms1f42.s[77]++, this.props),
          onFilter = _ref8.onFilter;

      var change = (cov_hcwms1f42.s[78]++, this.geHandleMax(e));
      cov_hcwms1f42.s[79]++;

      if (!change) {
        cov_hcwms1f42.b[25][0]++;
        cov_hcwms1f42.s[80]++;
        return;
      } else {
        cov_hcwms1f42.b[25][1]++;
      }

      var text = (cov_hcwms1f42.s[81]++, e.target.innerText.replace('\feff ', ''));
      cov_hcwms1f42.s[82]++;
      this.lastCursorOffset = getCursorOffset(text.length);
      var t = (cov_hcwms1f42.s[83]++, this.getProcessedValue(text));
      cov_hcwms1f42.s[84]++;

      if (onFilter) {
        cov_hcwms1f42.b[26][0]++;
        cov_hcwms1f42.s[85]++;
        onFilter(t);
      } else {
        cov_hcwms1f42.b[26][1]++;
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      cov_hcwms1f42.f[16]++;

      var _ref9 = (cov_hcwms1f42.s[86]++, this.props),
          txt = _ref9.text;

      var text = (cov_hcwms1f42.s[87]++, this.getProcessedValue(e.target.innerText.replace('\feff ', '')));
      cov_hcwms1f42.s[88]++;
      this.focusInput(false);
      cov_hcwms1f42.s[89]++;

      if (text === txt) {
        cov_hcwms1f42.b[27][0]++;
        cov_hcwms1f42.s[90]++;
        return;
      } else {
        cov_hcwms1f42.b[27][1]++;
      }

      cov_hcwms1f42.s[91]++;
      this.props.onInputBlur(text);
    }
  }, {
    key: "handleCompositionStart",
    value: function handleCompositionStart() {
      cov_hcwms1f42.f[17]++;
      cov_hcwms1f42.s[92]++;
      this.composition = true;
    }
  }, {
    key: "handleCompositionEnd",
    value: function handleCompositionEnd(e) {
      cov_hcwms1f42.f[18]++;
      cov_hcwms1f42.s[93]++;
      this.composition = false;
      cov_hcwms1f42.s[94]++;
      this.handleInput(e);
    }
  }, {
    key: "render",
    value: function render() {
      cov_hcwms1f42.f[19]++;

      var _ref10 = (cov_hcwms1f42.s[95]++, this.props),
          text = _ref10.text,
          focus = _ref10.focus,
          multiple = _ref10.multiple;

      var value = (cov_hcwms1f42.s[96]++, typeof text === 'string' ? (cov_hcwms1f42.b[28][0]++, text.replace(/<\/?[^>]*>/g, '')) : (cov_hcwms1f42.b[28][1]++, text));
      var props = (cov_hcwms1f42.s[97]++, {
        className: selectClass('input', (cov_hcwms1f42.b[29][0]++, !focus) && (cov_hcwms1f42.b[29][1]++, 'ellipsis'), (cov_hcwms1f42.b[30][0]++, !multiple) && (cov_hcwms1f42.b[30][1]++, 'full')),
        ref: this.bindElement,
        key: 'input',
        onInput: this.handleInput,
        contentEditable: (cov_hcwms1f42.b[31][0]++, focus) || (cov_hcwms1f42.b[31][1]++, this.state.editable),
        onFocus: handleFocus,
        onBlur: this.handleBlur,
        title: (cov_hcwms1f42.b[33][0]++, !focus) && (cov_hcwms1f42.b[33][1]++, isString(value)) ? (cov_hcwms1f42.b[32][0]++, value) : (cov_hcwms1f42.b[32][1]++, undefined),
        onCompositionStart: this.handleCompositionStart,
        onCompositionEnd: this.handleCompositionEnd
      });
      cov_hcwms1f42.s[98]++;

      if (
      /*#__PURE__*/
      isValidElement(value)) {
        cov_hcwms1f42.b[34][0]++;
        cov_hcwms1f42.s[99]++;

        if (value.type.toString() === 'Symbol(react.fragment)') {
          cov_hcwms1f42.b[35][0]++;
          cov_hcwms1f42.s[100]++;
          return (
            /*#__PURE__*/
            cloneElement(
            /*#__PURE__*/
            React.createElement("span", {
              __self: this,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 231,
                columnNumber: 29
              }
            }, value), _objectSpread2(_objectSpread2({}, props), {}, {
              suppressContentEditableWarning: true
            }))
          );
        } else {
          cov_hcwms1f42.b[35][1]++;
        }

        cov_hcwms1f42.s[101]++;
        return (
          /*#__PURE__*/
          cloneElement(value, _objectSpread2(_objectSpread2({}, props), {}, {
            // @ts-ignore
            // cloneElement 中的默认类型 React.HTMLAttributes 缺失 suppressContentEditableWarning
            suppressContentEditableWarning: true
          }))
        );
      } else {
        cov_hcwms1f42.b[34][1]++;
      } // @ts-ignore


      cov_hcwms1f42.s[102]++;
      return (
        /*#__PURE__*/
        React.createElement("span", Object.assign({
          dangerouslySetInnerHTML: {
            __html: value
          }
        }, props, {
          onPaste: this.handlePaste,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 244,
            columnNumber: 12
          }
        }))
      );
    }
  }]);

  return FilterInput;
}(Component);

FilterInput.defaultProps = DefaultValue;
export default FilterInput;